import { createContext, useContext, useState } from 'react';

const ProgressContext = createContext<any>({});
export const ProgressProvider = ({ children }) => {
    const [progress, setProgress] = useState(0);
    const [total, setTotal] = useState(0);
    const [done, setDone] = useState(0);
    const [showProgress, setShowProgress] = useState(true);

    return (
        <ProgressContext.Provider
            value={{ progress, setProgress, showProgress, setShowProgress, total, setTotal, done, setDone }}>
            {children}
        </ProgressContext.Provider>
    );
};
const useProgressProvider = () => useContext(ProgressContext);

export default useProgressProvider;
